/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2025, Zumper
 * @description ListingCardDescription
 */

interface ListingCardDescriptionProps {
  description: string
  isSpotlight?: true
}

export const ListingCardDescription = ({
  description,
  isSpotlight,
}: ListingCardDescriptionProps) => {
  return (
    <div className="flex flex-col text-sm gap-y-2">
      <div className={`font-bold ${isSpotlight ? 'text-gray-0' : 'text-gray-950'}`}>
        Description
      </div>
      <p className={`${isSpotlight ? 'text-neutral-200' : 'text-gray-600'} line-clamp-5`}>
        {description}
      </p>
    </div>
  )
}
